import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  HStack,
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Select,
  Grid,
  SimpleGrid,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Text,
  Progress,
  Container,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import AddRidersCard from './AddRidersCard'
import { SearchIcon } from "@chakra-ui/icons";
import './AddRiders.scss';

function AddRiders() {
  const Navigate = useNavigate();
  const save = () =>{
    Navigate('/dashboard/Riders');
  }
  return(
    <>
      <HStack justifyContent={'space-between'} mt={'60px'}>
        <Box>
          <h1 className='greet'>ADD RIDER</h1> 
          <p className='render__page'>RIDER LIST <span>/ ADD RIDER</span></p>  
        </Box>
      </HStack>
      <Card className="card_transaction" mt={'51px'}>
        <CardHeader className="card_header">
          <Heading className="heading" size='md'>RIDER AND MOTORCYCLE INFORMATION</Heading>
          <Text className="text">Enter Rider Information Here</Text>
        </CardHeader>
        <AddRidersCard />
        <Stack className="btn" position={'relative'} direction={['column', 'row']} mt={'47px'} spacing='30px'>
            <Button bg='#E93423' onClick={save}>
              <span className="icon"><FontAwesomeIcon icon={faPlus} /></span>UPLOAD
            </Button>
            <Button className="cancel" onClick={save}>
             <span className="icon"><FontAwesomeIcon icon={faXmark} /></span>CANCEL
            </Button>
        </Stack>
      </Card>
    </>
    
  );
}

export default AddRiders;
